import React__default from 'react';
import { Box } from '@mui/material';

var DefaultIcon = function (_a) {
    var sx = _a.sx, className = _a.className, children = _a.children, testId = _a.testId, id = _a.id, onMouseDown = _a.onMouseDown, title = _a.title;
    return (React__default.createElement(Box, { id: id, component: "i", sx: sx, "data-testid": testId, className: "fas ".concat(className), onMouseDown: onMouseDown, title: title }, children));
};

export { DefaultIcon as default };
//# sourceMappingURL=index.js.map
